<div *ngIf="entityTypes$ | async as entityType" class="entity-editor">
  <ng-container *ngIf="entityType">
    <ng-container *ngFor="let groupType of filteredGroups$ | async">
      <app-entity-group
        *ngIf="entity.Groups[groupType.Key].Rules.VisibleIf !== false"
        [entity]="entity"
        [groupType]="groupType"
        [entityForm]="entityFormGroup"
        (propertyChange)="propertyChanged($event)"
      >
      </app-entity-group>
    </ng-container>
  </ng-container>
</div>
